import { GridColDef } from '@mui/x-data-grid';

import MyDataGrid, { renderStrongHeader } from "~/mui/MyDataGrid";
import { classNames } from "~/utils/utils";

import "./style.less";

interface IStatisticsTableProps {
	data: {
		columns: GridColDef[];
		rows: any;
		pinnedRows: Array<Array<string>>;
	};
}

export default function StatisticsTable({
	data,
}: IStatisticsTableProps) {
	const { columns, rows, pinnedRows } = data;

	const updatedColumns = columns.map(item => ({
		...item,
		renderHeader: renderStrongHeader,
		disableColumnMenu: true,
		flex: 1,
		resizable: false,
	}));

	function calcWidth(count: number) {
		/* eslint-disable-next-line */
		return `${100 / count}%`;
	}

	/* eslint-disable react/no-array-index-key */
	return (
		<MyDataGrid
			rows={rows}
			columns={updatedColumns}
			autoHeight
			disableRowSelectionOnClick
			initialState={{
				sorting: {
					sortModel: [{ field: 'month', sort: 'desc' }],
				},
			}}
			slots={{
				footer: () => (<>
					{ pinnedRows.map((row, rowInd) => <div className={classNames(["statisticTable__footerLine", rowInd === 0 ? "top-line" : ""])} key={`row-${rowInd}`}>
						{ row.map((cell, cellInd) => <span className="statisticTable__footerCell" key={`cell-${rowInd}-${cellInd}`} style={{ maxWidth: calcWidth(row.length) }}>
							<strong>
								{ cell }
							</strong>
						</span>)}
					</div>)}
				</>),
			}}
		/>
	);
}
